import axios from 'axios'
import qs from 'qs'
import util from '../scripts/common/util'
// axios 配置
let instance = axios.create({
    //baseURL:'http://192.168.123.106:8087/',//朱亚军
    //baseURL:'https://develop.operate.jia-r.com/',//开发新
    //baseURL:'https://test.operate.jia-r.com/',//https测试测试新
    baseURL:'https://test02.operate.yun-r.com/',//https测试测试新
    //baseURL:'https://tmp.operate.jia-r.com',//临时环境
    // baseURL:'https://operate.yun-r.com',//集群环境
    //baseURL:'https://operate.jia-r.com/',//正式新
    //timeout: 60000,
    //headers: {'content-type': 'application/x-www-form-urlencoded;charset=UTF-8'}
    //headers:{'content-type': 'application/json;charset=UTF-8'}
});
export function fetch(url, param, formData=false, timeout = 10000) {
  return new Promise((resolve, reject) => {

  let params;
  let contentType = "application/x-www-form-urlencoded;charset=UTF-8";
  if (formData) {
      //如果有文件流需要formData格式，分开传参json格式的param和文件格式的formData，其他接口默认formData为false
      //form表单所需contentType
      contentType = 'multipart/form-data';
  }
  //验签value加密处理
  let valueStr = util.jsonSort(Object.assign( param));
  let createTime=util.formatDate.format(new Date(), 'yyyyMMddhhmmss');
  let key="ITL87v5ik7*=()55ilpp751O";
  let sign=util.getmd5(valueStr+createTime+key);
  // console.log(sign)
  //AES加密
  let pubkey="5278MMN5412365UH"
  let data=Object.assign( param,{"createTime":createTime,"sign":sign});
  console.log(data)
  let ciphertext = util.encryptByAES(JSON.stringify(data), pubkey);
  if (formData) {
    formData.append("encryptScript", ciphertext);
    params=formData;
  }else {
    params=qs.stringify(Object.assign({encryptScript:ciphertext}))
  }
  let config = {
    headers: {'Content-Type': contentType,'itlong-face-sign':'asdasd'},
    timeout: timeout,
  };
  console.log(config)
  instance.post(url, params, config)
    .then(response => {
      let encryptScript=util.decryptByAES(response.data.encryptScript,pubkey);
        console.log(JSON.parse(encryptScript))
      if(JSON.parse(encryptScript).allData){
          console.log(url)
      console.log(JSON.parse(JSON.parse(encryptScript).allData))
        let resSign=util.getmd5(JSON.parse(encryptScript).allData+JSON.parse(encryptScript).createTime+key)
        if(resSign == JSON.parse(encryptScript).sign) {//验签
          resolve(JSON.parse(JSON.parse(encryptScript).allData));
        }else{
          resolve(JSON.parse('{"msgCode":"SmsgCode","msg":"验签失败"}'));
        }
      }else{
        resolve(JSON.parse(encryptScript));
      }
    }, err => {
      reject(err);
    })
    .catch((error) => {
      reject(error)
    })
  })
}
export default {

/*------------------------------------证书管理-----------------------------------------------------*/

  /**
   * 在线查询证书
   */
  getLicense(params) {
    return fetch('operate/project/online/getLicense', params)
  },
  /**
   * 保存特征码
   */
  savePCInfo(params) {
    return fetch('operate/project/online/savePCInfo', params)
  },
  /**
   * 下载证书
   */
  licenseDownload(params) {
    return fetch('operate/project/online/licenseDownload', params)
  },
}



// WEBPACK FOOTER //
// ./src/fetch/api.js